import type { IFile } from '@/types/Data'
import type { IPayloadFile } from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class FileServices extends BaseService {
  GetFileList() {
    return this.GET<IFile[]>(this.PATHS.GET_FILE_LIST)
  }

  UploadFile(data: IPayloadFile) {
    return this.POST<IFile>(this.PATHS.UPLOAD_FILE, JsonToFormData(data))
  }

  DeleteFile(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_FILE, null, { Id })
  }

  UpdateFile(data: IPayloadFile) {
    return this.PUT<IFile>(this.PATHS.UPDATE_FILE, JsonToFormData(data))
  }
}
